import React, { useCallback } from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import cn from 'classnames';

// Types
import { ItemType } from 'Shared/constants/types';

// Selectors
import { getMeetingItemByUuid } from 'Shared/selectors/common';

// Utils
import { isInThePast } from 'Shared/utils/DateTime.utils';

// Components
import { WpAvatar } from 'Wpds/components/avatar';
import ViewDetailsButton from 'Shared/components/MeetingItemsContainer/partials/ViewDetailsButton';

// Styles
import './ActionsAreaForMobile.scss';

type Props = {
  uuid: string;
  onCommentButtonClick?: Function;
};

function ActionsAreaForMobile({ uuid, onCommentButtonClick }: Props) {
  const { itemType, isSection, completed, assignmentAvatar, due_by: dueBy } = useSelector(getMeetingItemByUuid(uuid));

  const isActionItem = itemType === ItemType.actionItem;

  const handleActionsAreaClick = () => {
    onCommentButtonClick();
  };

  const isDueDateInThePast = useCallback(() => Boolean(!completed && dueBy && isInThePast(dueBy)), [completed, dueBy]);

  const baseClassName = 'ActionsAreaForMobile';

  return (
    <div className={baseClassName} onClick={handleActionsAreaClick}>
      {dueBy && (
        <span className={cn('mr-2', { 'text-danger': isDueDateInThePast(), 'text-muted': !isDueDateInThePast() })}>
          {moment.unix(dueBy).format('MMM. DD')}
        </span>
      )}
      {isActionItem && assignmentAvatar && (
        <div className={`${baseClassName}__avatar`}>
          <WpAvatar size="sm" avatar={assignmentAvatar} />
        </div>
      )}
      {!isSection && <ViewDetailsButton uuid={uuid} />}
    </div>
  );
}

export default React.memo(ActionsAreaForMobile);
